import React, { useEffect, useState } from "react";
import axios from "axios";
import { KeyUri } from "../key";
import { motion } from "framer-motion";
import { Grid, Card, CardMedia, CardContent, Typography, Button, Box } from "@mui/material";



const Offers = () => {
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [copiedCouponId, setCopiedCouponId] = useState(null);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await axios.get(`${KeyUri.BACKEND_URI}/get-all-coupon`);
        const activeCoupons = response.data.filter(
          (coupon) =>
            coupon.is_active && new Date(coupon.expiration_date) > new Date()
        );
        setCoupons(activeCoupons.slice(0, 30));
      } catch (error) {
        console.error("Error fetching coupons:", error);
      }
    };
    fetchCoupons();
  }, []);

  const handleCopy = async (code, id) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopiedCouponId(id);
      setTimeout(() => setCopiedCouponId(null), 1000);
      setSelectedCoupon(null);
    } catch (e) {
      alert("Failed to copy code.");
    }
  };

  // Card renderer utility
  const renderStaticCards = (arr) => (
    <div style={{ display: "flex", gap: 20, overflowX: "auto", paddingBottom: 20 }}>
      {arr.map((card, idx) => (
        <Card key={idx} sx={{ minWidth: 260, maxWidth: 280, boxShadow: 3 }}>
          <CardMedia
            component="img"
            height="150"
            image={card.img}
            alt={card.title}
            sx={{ objectFit: "cover" }}
          />
          <CardContent>
            <Typography variant="h6" color="primary" gutterBottom>{card.title}</Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>{card.desc}</Typography>
            <Button
              href={card.link}
              variant="contained"
              size="small"
              sx={{ mt: 1, bgcolor: "primary.main" }}
            >
              Book Now
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );

  return (
    <div style={{ padding: "2rem 1rem", background: "#f6f7fb", fontFamily: "lato,sans-serif" }}>
      <h2 style={{ textAlign: "center", color: "#1e429f", fontWeight: "bold", fontSize: 32, marginBottom: 28 }}>
        Latest Offers
      </h2>

      {/* Dynamic Coupons */}
      <div style={{ display: "flex", gap: 20, overflowX: "auto", paddingBottom: 20 }}>
        {coupons.map((coupon, idx) => (
            <motion.div
      key={coupon._id}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: idx * 0.07 }}
      whileHover={{
        scale: 1.045,
        boxShadow: "0 8px 42px rgba(30,66,159,0.14)"
      }}
      style={{ borderRadius: 13 }}
    >
          <Card
            key={coupon._id}
            sx={{ minWidth: 350, maxWidth: 350, boxShadow: 3, position: "relative", borderRadius: 5, display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2 }}
          >
              <CardMedia
      component="img"
      height="150"
      image={coupon.img || "path/to/default-placeholder.jpg"} // fallback image if none
      alt={coupon.coupon_name}
      sx={{  width: "120px", 
      height: "120px", 
      objectFit: "cover",
      marginLeft: "10px",
      flexShrink: 0 }}
    />
            <CardContent
              style={{   cursor: "pointer", flex: 1, padding: "16px" }}
              onClick={() =>
                setSelectedCoupon(selectedCoupon === coupon._id ? null : coupon._id)
              }
            >
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <span style={{
                  fontSize: 12, background: "#fde68a",
                  color: "#a16207", padding: "2px 8px",
                  borderRadius: 8
                }}>
                  {coupon.coupon_category || "Offer"}
                </span>
                {coupon.is_single_use && (
                  <span style={{
                    fontSize: 12, background: "#fee2e2",
                    color: "#dc2626", padding: "2px 8px",
                    borderRadius: 8
                  }}>
                    Single Use
                  </span>
                )}
              </div>
              <Typography variant="h6" color="primary" gutterBottom style={{ marginBottom: 5 }}>
                {coupon.coupon_name}
              </Typography>
              <Typography variant="body2" color="text.secondary" style={{ marginBottom: 5 }}>
                Code: <span style={{ fontFamily: "monospace", fontWeight: "bold" }}>{coupon.coupon_code}</span>
              </Typography>
              {selectedCoupon === coupon._id && (
                <div style={{
                  display: "flex", alignItems: "center", background: "#e0e7ff",
                  padding: "4px 12px", borderRadius: 8, marginBottom: 8, width: "fit-content"
                }}>
                  <span style={{
                    fontFamily: "monospace", fontSize: 18, color: "#1e429f", marginRight: 8
                  }}>{coupon.coupon_code}</span>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      bgcolor: "#2563eb"
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      handleCopy(coupon.coupon_code, coupon._id);
                    }}
                  >
                    {copiedCouponId === coupon._id ? "Copied!" : "Copy Code"}
                  </Button>
                </div>
              )}
              <Typography variant="body2" color="text.secondary" style={{ marginBottom: 5 }}>
                Discount: {coupon.discount_type === "percentage"
                  ? `${coupon.coupon_amount}% off (Max ₹${coupon.max_discount_amount})`
                  : `Flat ₹${coupon.coupon_amount} off`}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Valid till: {new Date(coupon.expiration_date).toLocaleDateString()}
              </Typography>
            </CardContent>
          </Card>
          </motion.div>
        ))}
      </div>

     
     

     
    </div>
  );
};

export default Offers;
